module.exports = __webpack_public_path__ + "static/media/reddit.885ce903.svg";